import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 pl-4 pr-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" })
  ])
], -1)
const _hoisted_9 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_10 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "px-4 pb-8 mt-4 border-b border-gray-400" }
const _hoisted_14 = { class: "space-y-4" }
const _hoisted_15 = { class: "text-sm font-bold" }
const _hoisted_16 = { class: "text-sm font-bold" }
const _hoisted_17 = { class: "flex justify-between px-4 py-3 bg-gray-50" }

import { ref } from "vue";
import DefaultButton from "../DefaultButton.vue";
import { formatDate } from "@/utils/dates";
import api from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportDataModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
},
  emits: ["close", "delete"],
  setup(__props, { emit: emits }) {

const props = __props;




const isLoading = ref(false);

const start_datepicker = ref(null);
const end_datepicker = ref(null);

const start = ref("");
const end = ref("");

/** Set Dates function */
function setDate(datepicker: string, e: Date) {
  if (!e) return;

  if (datepicker === "start") {
    start.value = formatDate(e);

    // @ts-ignore
    start_datepicker.value.closeMenu();
  }

  if (datepicker === "end") {
    end.value = formatDate(e);

    // @ts-ignore
    end_datepicker.value.closeMenu();
  }
}

/** Export data function */
async function submit() {
  try {
    isLoading.value = true;
    if (props.type === "clubs") {
      const response = (
          await api.reports.exportBrickClubData({
            start: start.value,
            end: end.value,
          })
        ).data;
      window.open(response.url);
    } else {
      const response = (
          await api.reports.exportBrickClubGoalsData({
            start: start.value,
            end: end.value,
          })
        ).data;
      window.open(response.url);
    }

    
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

/** Close function */
function setIsOpen() {
  emits("close");
}

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(props.title), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: setIsOpen }, _hoisted_12)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("start-date")), 1),
                      _createVNode(_component_DatePicker, {
                        class: "mt-1",
                        ref_key: "start_datepicker",
                        ref: start_datepicker,
                        modelValue: start.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((start).value = $event)),
                        onInternalModelChange: _cache[1] || (_cache[1] = e => setDate('start', e)),
                        required: "",
                        "enable-time-picker": false,
                        format: "dd/MMM/yyyy",
                        "max-date": new Date()
                      }, null, 8, ["modelValue", "max-date"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("end-date")), 1),
                      _createVNode(_component_DatePicker, {
                        class: "mt-1",
                        ref_key: "end_datepicker",
                        ref: end_datepicker,
                        modelValue: end.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((end).value = $event)),
                        onInternalModelChange: _cache[3] || (_cache[3] = e => setDate('end', e)),
                        required: "",
                        "enable-time-picker": false,
                        format: "dd/MMM/yyyy",
                        "max-date": new Date()
                      }, null, 8, ["modelValue", "max-date"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(DefaultButton, {
                  type: "danger",
                  onAction: setIsOpen
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("cancel")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DefaultButton, {
                  type: "primary",
                  onAction: submit,
                  loading: isLoading.value,
                  disabled: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("export-data")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})